
















































































































































































import Vue from 'vue'

import {getUserInfo} from "@/utils/auth";
import {MasterlinkTenantServiceProxy} from "@/service-proxies/app-v2/system.service-proxies";
import {GatewayServiceProxy, ProductBatchServiceProxy} from "@/service-proxies/app-v2/iot-console.service-proxies";
import Toolbar from './components/Toolbar.vue'
import GatewayList from './components/GatewayList.vue'
import GatewayDetail from './components/GatewayDetail.vue'
import {statusList} from "@/views/console/gateway-list/components/data";
import RegisterModal from '@/views/console/gateway-list/components/RegisterModal.vue'
import GatewayTransfer from '@/views/console/gateway-list/components/GatewayTransfer.vue'
import TransferRecord from '@/views/console/gateway-list/components/TransferRecord.vue'
import {iotExport} from "@/api/api";

const batchServ = new ProductBatchServiceProxy()
const gsp = new GatewayServiceProxy()
const systemService = new MasterlinkTenantServiceProxy()
const recycleGateway = gsp.recycleGateway.bind(gsp) // 回收网关

export default Vue.extend({
  components: {
    Toolbar,
    GatewayList,
    GatewayDetail,
    RegisterModal,
    GatewayTransfer,
    TransferRecord
  },
  data() {
    return {

      gatewayList: [],
      gateway: undefined,
      collapsed: true,
      batchList: [],
      selectParam: {
        loginTenantId:'',
        filter: '',
        tenantId: undefined,
        isOnline: undefined,
        batchCode: undefined,
        workStationIdPattern: undefined
      },
      recycleGatewayVisible: false,
      targetTenantName: '',
      selectedRowKeys:[],
      selectedRows:[],
      tenants:[],
      selectGatewayIds:[]
    }
  },

  computed: {

    statusList() {
      return statusList.map((item) => {
        return {
          ...item,
          label: this.$t(item.label)
        }
      })
    },
    // gateway(){
    //   debugger
    //   if (this.$refs.gatewayList && this.$refs.gatewayList.selectedRows.length > 0){
    //     return this.$refs.gatewayList.selectedRows[0]
    //   } else {
    //     return undefined
    //   }
    // }
  },
  async mounted() {
    this.selectParam.tenantId = this.$refs.tenantSelect.selectedValue
    this.selectParam.loginTenantId = this.getTenantId()
    const {
      data: { records }
    } = await systemService.getTenants(undefined, 1, -1, undefined, undefined)

    this.tenants = records.map((item) => ({ label: item.tenantName, value: item.tenantId, code: item.tenantCode }))
    const { items } = await batchServ.getList(undefined)

    this.batchList = items.map((c) => ({ label: c.batchNo, value: c.batchNo }))
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    exportTable() {
      let {  filter, tenantId, isOnline, batchCode, workStationIdPattern } = this.selectParam
      const loginTenantId = this.getTenantId()
      const ids = this.$refs.gatewayList.gatewayList
          .filter((res) => this.selectedRowKeys.indexOf(res.code) != -1)
          .map((item) => item.id)
      let params: any = {
        filter: filter,
        idList: ids,
        workStationIdPattern: workStationIdPattern,
        tenantId: loginTenantId === '000000' ? tenantId : loginTenantId,
        isOnline: String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined,
        batchCode
      }
      iotExport(params).then((res) => {
        var a = document.createElement('a')
        a.download = `${this.$t('page_devices_management')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },
    openRegisterModal() {
      this.$refs.registerModal.trigger()
    },
    trigger() {
      this.recycleGatewayVisible = !this.recycleGatewayVisible
      this.targetTenantName = ''
    },
    // 回收网关
    async recycleGateway() {
      let ids = this.selectedRows.map((item) => item.id)
      let params = {
        gatewayIdList: ids,
        targetTenantName: this.targetTenantName
      }
      try {
        await recycleGateway(params)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.recycleGatewayVisible = false
        this.getGatewayList(true)
      } catch (e) {
        console.log(e)
      }
    },
    onChangeGateway(record){
      this.gateway=record
    },
    onSelectGateway(list){
      // console.log("list",list)
    },
    collapse(){
      this.collapsed=!this.collapsed;
    },

    getTenantId() {
      const info = getUserInfo()
      return info.tenant_id || ''
    },
    getGatewayListDate(reload){
      this.$refs.gatewayList.getGatewayList(reload)
    },
    selectValueChange(){
      this.selectParam.tenantId = this.$refs.tenantSelect.selectedValue
      this.getGatewayListDate(true);

    },
    selectedRowKeysChange(){
      this.selectedRowKeys = this.$refs.gatewayList.selectedRowKeys
      this.selectedRows = this.$refs.gatewayList.selectedRows
      this.selectGatewayIds = this.$refs.gatewayList.selectGatewayIds
    },
    getImageUrl(gatewayType){
      return this.$refs.gatewayList.getImageUrl(gatewayType);
    },
    changeCurremt(){
      this.$refs.gatewayDetail.initCurremt()
    }
  },
  watch:{

  }
})
